import I18n from 'i18n'
import { takeLatest, call, put } from 'redux-saga/effects'

import UploadFile from 'api/commons/UploadFile'
import { ErrorToast } from 'components/ui/toast/toastsTemplates'
import * as fromActions from '../../actions/externalCourses.action'

const externalCourseUpload = (file: File) => {
  return UploadFile(file, '/external_courses/imports')
}

function* externalCourseUploadEffectSaga(action: any) {
  try {
    const { data } = yield call(externalCourseUpload, action.payload)
    // dispatch action to change redux state
    yield put(fromActions.Actions.uploadFileSuccess(data))
    yield put(
      fromActions.Actions.getList({
        page: 1,
        searchText: '',
      })
    )
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.deleteError'))
    console.log('error: ', error)
  }
}

export function* externalCourseUploadWatcherSaga() {
  yield takeLatest(
    fromActions.EXTERNAL_COURSE_UPLOAD,
    externalCourseUploadEffectSaga
  )
}
